import {UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {InterventionTeamContactDto} from "../intervention-team-contact.dto";

export class NewTeamContactForm extends UntypedFormGroup {

  constructor() {
    super({
      email: new UntypedFormControl('', [Validators.required]),
      language: new UntypedFormControl('', [Validators.required]),
      firstName: new UntypedFormControl('', [Validators.required]),
      lastName: new UntypedFormControl('', [Validators.required]),
      company: new UntypedFormControl(''),
      birthday: new UntypedFormControl(''),
      gender: new UntypedFormControl(''),
      telephone: new UntypedFormControl(''),
      nationalRegistrationNumber: new UntypedFormControl(''),
    });
  }

  public get model(): InterventionTeamContactDto {
    return this.value as InterventionTeamContactDto;
  }

  public get emailField() {
    return this.controls.email as UntypedFormControl;
  }

  public get languageField() {
    return this.controls.language as UntypedFormControl;
  }

  public get firstNameField() {
    return this.controls.firstName as UntypedFormControl;
  }

  public get lastNameField() {
    return this.controls.lastName as UntypedFormControl;
  }

  public get companyField() {
    return this.controls.company as UntypedFormControl;
  }

  public get dateOfBirthField() {
    return this.controls.birthday as UntypedFormControl;
  }

  public get genderField() {
    return this.controls.gender as UntypedFormControl;
  }

  public get phoneNumberField() {
    return this.controls.telephone as UntypedFormControl;
  }

  public get nationalRegistrationNrField() {
    return this.controls.nationalRegistrationNumber as UntypedFormControl;
  }

  public static from(contact?: InterventionTeamContactDto): NewTeamContactForm {
    const instance = new NewTeamContactForm();
    if (contact) {
      Object.keys(instance.controls).forEach(field => {
        instance.controls[field].setValue(contact[field])
      });
    }
    return instance;
  }
}
